import React from "react";
import { IDoctor } from "../../../../dto/interfaces";
import MapEmbed from "../../../../components/mapEmbed";
import ContactCard from "./ContactUsCard";
import { getGoogleMapsEmbedUrl } from "../../../../utils/mapUtils";

interface DoctorProfileParams {
    doctor: IDoctor;
}

const ContactSection: React.FC<DoctorProfileParams> = ({ doctor }) => {
    const mapSearchUrl = getGoogleMapsEmbedUrl(doctor?.address);
    return (
        <section id="contact-doctor" className="py-6 md:py-10">
            <div className="container mx-auto px-2 md:px-6">
                <div className="relative w-full h-fit md:h-[600px] rounded-[32px] overflow-hidden">
                    {/* 1. The Reusable Map (as background) */}
                    <MapEmbed url={mapSearchUrl} className="absolute inset-0 w-full h-full hidden md:block" />

                    {/* 2. The Contact Card (Overlaid) */}
                    <div
                        className="hidden md:block absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full md:w-[90%] md:max-w-md 
                          md:left-auto md:translate-x-0 md:right-8 lg:right-12"
                    >
                        <ContactCard doctor={doctor} />
                    </div>
                    <div>
                        {/* Mobile View: Contact Card Below Map */}
                        <div className="md:hidden">
                            <ContactCard doctor={doctor} />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ContactSection;
